import {
  Button,
  Col,
  Divider,
  Modal,
  Row,
  Space,
  Table,
  Typography,
  Radio,
  InputNumber,
} from 'antd';
import { ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import React, { FC, useCallback, useMemo, useState } from 'react';
import Link from 'antd/lib/typography/Link';
import { useParams } from 'react-router';
import { AutoCompleteInput } from '../../../../../form/adapters/AutoCompleteInput';
const { confirm } = Modal;
const { Text } = Typography;

type Props = {
  internalCustomers: {
    criteriaSet: { id: number; name: string; criterias: any[] };
    criteriaSetName: string;
    internalCustomer: { id: number; value: string };
    internalCustomerName: string;
    key: number;
    weight?: number;
    reviewType?: 'all' | 'lead' | 'member';
    type: 'team' | 'user';
    user?: number;
    status?: string;
  }[];
  criteriaSet: any[];
  teamSet: any[];
  userSet: any[];
  onChange: (
    reviewers: {
      entityId: number;
      criteriaSetId: number;
      type: 'team' | 'user';
      weight: number;
      reviewType: 'all' | 'lead' | 'member';
      user?: number;
    }[],
  ) => void;
  label: string;
  leader?: boolean;
  leadId?: number;
};

const options = [
  { label: 'Team', value: 'team' },
  { label: 'User', value: 'user' },
];

const options1 = [
  { label: 'All', value: 'all' },
  { label: 'Team Leads', value: 'lead' },
  { label: 'Team Members', value: 'member' },
];

export const InternalCustomerManger: FC<Props> = (props) => {
  const { internalCustomers, criteriaSet, teamSet, userSet, onChange, label, leader, leadId } =
    props;

  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [modalVisible1, setModalVisible1] = useState<boolean>(false);
  const [selectedInternalCustomer, setSelectedInternalCustomer] = useState<{
    id: number;
    value: string;
  }>();
  const [selectedOldInternalCustomer, setSelectedOldInternalCustomer] = useState<{
    id: number;
    value: string;
  }>();
  const [internalCustomerType, setInternalCustomerType] = useState<'team' | 'user'>(
    teamSet.length !== 0 ? 'team' : 'user',
  );
  const [internalValue, setInternalValue] = useState<number | undefined>();
  const [reviewType, setReviewType] = useState<'all' | 'lead' | 'member'>('all');
  const [weight, setWeight] = useState<number>(0);
  const [selectedStatus, setSelectedStatus] = useState<string | undefined>();
  const [internalCustomerIds] = useState<number[]>(internalCustomers.map((e) => e.key));
  const params = useParams<{ cycle: string; id: string; name: string }>();

  const columns = useMemo(() => {
    return [
      {
        title: label,
        dataIndex: 'internalCustomerName',
        key: 'internalCustomer',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <div>
            <Link
              onClick={() => {
                setInternalCustomerType(record.type);
                setInternalValue(record?.criteriaSet?.id);
                setSelectedInternalCustomer(record?.internalCustomer);
                setSelectedOldInternalCustomer(record?.internalCustomer);
                setWeight(record?.weight ?? 0);
                setReviewType(record?.reviewType ?? 'all');
                setSelectedStatus(record?.status);
                setModalVisible1(true);
              }}>
              {text}
            </Link>
          </div>
        ),
      },
      {
        title: 'Criteria Set',
        dataIndex: 'criteriaSetName',
        key: 'criteriaSet',
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Text>{record.type === 'team' ? 'Team' : 'User'}</Text>
        ),
      },
      {
        title: 'Weight',
        dataIndex: 'weight',
        key: 'weight',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => <Text>{record.weight}</Text>,
      },
      {
        title: 'Percentage',
        dataIndex: 'weight',
        key: 'percentage',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Text>
            {isNaN(
              (+record.weight /
                internalCustomers
                  .filter((e) => e.user === leadId)
                  .reduce((x, y) => x + +(y?.weight ?? 0), 0)) *
                100,
            )
              ? '0.00 '
              : (
                  (+record.weight /
                    internalCustomers
                      .filter((e) => e.user === leadId)
                      .reduce((x, y) => x + +(y?.weight ?? 0), 0)) *
                  100
                ).toFixed(2)}{' '}
            %
          </Text>
        ),
      },
    ];
  }, [internalCustomers, label, leadId]);

  const showDeleteConfirm = useCallback(() => {
    confirm({
      title: `Deleting ${label}!`,
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure delete this ${label}?`,
      okText: 'Yes,Delete!',
      centered: true,
      okType: 'primary',
      cancelText: 'Cancel',
      onOk: function () {
        let internalUsers: any[] = [];
        let internalTeams: any[] = [];
        if (internalCustomerType === 'user') {
          internalUsers = internalCustomers
            .filter((e) => e.type === 'user')
            .filter(
              (item) =>
                !(
                  item?.internalCustomer?.id === selectedOldInternalCustomer?.id &&
                  item?.user === leadId
                ),
            )
            .map((item1) =>
              item1?.user
                ? {
                    entityId: item1?.internalCustomer?.id,
                    criteriaSetId: item1?.criteriaSet?.id,
                    type: 'user',
                    weight: item1?.weight ?? 0,
                    reviewType: item1?.reviewType ?? 'all',
                    user: item1?.user,
                  }
                : {
                    entityId: item1?.internalCustomer?.id,
                    criteriaSetId: item1?.criteriaSet?.id,
                    type: 'user',
                    weight: item1?.weight ?? 0,
                    reviewType: item1?.reviewType ?? 'all',
                  },
            );
          internalTeams = internalCustomers
            .filter((e) => e.type === 'team')
            .map((item1) =>
              item1?.user
                ? {
                    entityId: item1?.internalCustomer?.id,
                    criteriaSetId: item1?.criteriaSet?.id,
                    type: 'team',
                    weight: item1?.weight ?? 0,
                    reviewType: item1?.reviewType ?? 'all',
                    user: item1?.user,
                  }
                : {
                    entityId: item1?.internalCustomer?.id,
                    criteriaSetId: item1?.criteriaSet?.id,
                    type: 'team',
                    weight: item1?.weight ?? 0,
                    reviewType: item1?.reviewType ?? 'all',
                  },
            );
        } else if (internalCustomerType === 'team') {
          internalTeams = internalCustomers
            .filter((e) => e.type === 'team')
            .filter(
              (item) =>
                !(
                  item?.internalCustomer?.id === selectedOldInternalCustomer?.id &&
                  item?.user === leadId
                ),
            )
            .map((item1) =>
              item1?.user
                ? {
                    entityId: item1?.internalCustomer?.id,
                    criteriaSetId: item1?.criteriaSet?.id,
                    type: 'team',
                    weight: item1?.weight ?? 0,
                    reviewType: item1?.reviewType ?? 'all',
                    user: item1?.user,
                  }
                : {
                    entityId: item1?.internalCustomer?.id,
                    criteriaSetId: item1?.criteriaSet?.id,
                    type: 'team',
                    weight: item1?.weight ?? 0,
                    reviewType: item1?.reviewType ?? 'all',
                  },
            );
          internalUsers = internalCustomers
            .filter((e) => e.type === 'user')
            .map((item1) =>
              item1?.user
                ? {
                    entityId: item1?.internalCustomer?.id,
                    criteriaSetId: item1?.criteriaSet?.id,
                    type: 'user',
                    weight: item1?.weight ?? 0,
                    reviewType: item1?.reviewType ?? 'all',
                    user: item1?.user,
                  }
                : {
                    entityId: item1?.internalCustomer?.id,
                    criteriaSetId: item1?.criteriaSet?.id,
                    type: 'user',
                    weight: item1?.weight ?? 0,
                    reviewType: item1?.reviewType ?? 'all',
                  },
            );
        }
        const reviewers = [...internalTeams, ...internalUsers];

        onChange(reviewers);
        setInternalValue(undefined);
        setSelectedInternalCustomer(undefined);
        setSelectedOldInternalCustomer(undefined);
        setModalVisible(false);
        setWeight(0);
        setReviewType('all');
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }, [
    internalCustomerType,
    internalCustomers,
    label,
    leadId,
    onChange,
    selectedOldInternalCustomer?.id,
  ]);

  const setInternalCustomerValues = useCallback(() => {
    if (selectedInternalCustomer && internalValue) {
      const items: {
        entityId: number;
        criteriaSetId: number;
        type: 'team' | 'user';
        weight: number;
        reviewType: 'all' | 'lead' | 'member';
        user?: number;
      }[] = internalCustomers
        .filter((e) => e.type === 'team')
        ?.filter((item) =>
          internalCustomerType === 'team'
            ? !(
                item?.internalCustomer?.id === selectedInternalCustomer?.id && item?.user === leadId
              )
            : true,
        )
        .map((item) =>
          item?.user
            ? {
                entityId: item.internalCustomer.id,
                criteriaSetId: item.criteriaSet.id,
                type: 'team',
                weight: item?.weight ?? 0,
                reviewType: item?.reviewType ?? 'all',
                user: item?.user,
              }
            : {
                entityId: item.internalCustomer.id,
                criteriaSetId: item.criteriaSet.id,
                type: 'team',
                weight: item?.weight ?? 0,
                reviewType: item?.reviewType ?? 'all',
              },
        );
      const items2: {
        entityId: number;
        criteriaSetId: number;
        type: 'team' | 'user';
        weight: number;
        reviewType: 'all' | 'lead' | 'member';
        user?: number;
      }[] = internalCustomers
        .filter((e) => e.type === 'user')
        ?.filter((item) =>
          internalCustomerType === 'user'
            ? !(
                item?.internalCustomer?.id === selectedInternalCustomer?.id && item?.user === leadId
              )
            : true,
        )
        .map((item) =>
          item?.user
            ? {
                entityId: item.internalCustomer.id,
                criteriaSetId: item.criteriaSet.id,
                type: 'user',
                weight: item?.weight ?? 0,
                reviewType: item?.reviewType ?? 'all',
                user: item?.user,
              }
            : {
                entityId: item.internalCustomer.id,
                criteriaSetId: item.criteriaSet.id,
                type: 'user',
                weight: item?.weight ?? 0,
                reviewType: item?.reviewType ?? 'all',
              },
        );
      const reviewers = leadId
        ? [
            ...items,
            ...items2,
            {
              entityId: selectedInternalCustomer.id,
              criteriaSetId: internalValue,
              type: internalCustomerType,
              weight: weight,
              reviewType: reviewType,
              user: leadId,
            },
          ]
        : [
            ...items,
            ...items2,
            {
              entityId: selectedInternalCustomer.id,
              criteriaSetId: internalValue,
              type: internalCustomerType,
              weight: weight,
              reviewType: reviewType,
            },
          ];
      onChange(reviewers);
      setInternalValue(undefined);
      setSelectedInternalCustomer(undefined);
      setModalVisible(false);
      setWeight(0);
      setReviewType('all');
    }
  }, [
    internalCustomerType,
    internalCustomers,
    internalValue,
    leadId,
    onChange,
    reviewType,
    selectedInternalCustomer,
    weight,
  ]);

  const editInternalCustomerValues = useCallback(() => {
    if (selectedInternalCustomer && internalValue) {
      const items: {
        entityId: number;
        criteriaSetId: number;
        type: 'team' | 'user';
        weight: number;
        reviewType: 'all' | 'lead' | 'member';
        user?: number;
      }[] = internalCustomers
        .filter((e) => e.type === 'team')
        ?.filter(
          (item) =>
            !(
              item?.internalCustomer?.id === selectedOldInternalCustomer?.id &&
              item?.user === leadId
            ),
        )
        .map((item) =>
          item?.user
            ? {
                entityId: item.internalCustomer.id,
                criteriaSetId: item.criteriaSet.id,
                type: 'team',
                weight: item?.weight ?? 0,
                reviewType: item?.reviewType ?? 'all',
                user: item?.user,
              }
            : {
                entityId: item.internalCustomer.id,
                criteriaSetId: item.criteriaSet.id,
                type: 'team',
                weight: item?.weight ?? 0,
                reviewType: item?.reviewType ?? 'all',
              },
        );
      const items2: {
        entityId: number;
        criteriaSetId: number;
        type: 'team' | 'user';
        weight: number;
        reviewType: 'all' | 'lead' | 'member';
        user?: number;
      }[] = internalCustomers
        .filter((e) => e.type === 'user')
        ?.filter(
          (item) =>
            !(
              item?.internalCustomer?.id === selectedOldInternalCustomer?.id &&
              item?.user === leadId
            ),
        )
        .map((item) =>
          item?.user
            ? {
                entityId: item.internalCustomer.id,
                criteriaSetId: item.criteriaSet.id,
                type: 'user',
                weight: item?.weight ?? 0,
                reviewType: item?.reviewType ?? 'all',
                user: item?.user,
              }
            : {
                entityId: item.internalCustomer.id,
                criteriaSetId: item.criteriaSet.id,
                type: 'user',
                weight: item?.weight ?? 0,
                reviewType: item?.reviewType ?? 'all',
              },
        );
      const reviewers = leadId
        ? [
            ...items,
            ...items2,
            {
              entityId: selectedInternalCustomer.id,
              criteriaSetId: internalValue,
              type: internalCustomerType,
              weight: weight,
              reviewType: reviewType,
              user: leadId,
            },
          ]
        : [
            ...items,
            ...items2,
            {
              entityId: selectedInternalCustomer.id,
              criteriaSetId: internalValue,
              type: internalCustomerType,
              weight: weight,
              reviewType: reviewType,
            },
          ];
      onChange(reviewers);
      setInternalValue(undefined);
      setSelectedInternalCustomer(undefined);
      setSelectedOldInternalCustomer(undefined);
      setModalVisible(false);
      setWeight(0);
      setReviewType('all');
    }
  }, [
    internalCustomerType,
    internalCustomers,
    internalValue,
    leadId,
    onChange,
    reviewType,
    selectedInternalCustomer,
    selectedOldInternalCustomer,
    weight,
  ]);

  return (
    <div style={{ marginRight: 20, marginLeft: 20 }}>
      <Table
        dataSource={leadId ? internalCustomers.filter((e) => e.user === leadId) : internalCustomers}
        columns={columns}
        pagination={false}
      />
      {!leader && (
        <Button
          type="dashed"
          block
          onClick={() => {
            setInternalCustomerType(teamSet.length !== 0 ? 'team' : 'user');
            setModalVisible(true);
          }}>
          <PlusOutlined />
          Add a {label}
        </Button>
      )}
      <Modal
        open={modalVisible}
        onCancel={() => {
          setInternalValue(undefined);
          setSelectedInternalCustomer(undefined);
          setModalVisible(false);
        }}
        footer={
          <Row>
            <div style={{ flex: 1 }}>
              <Button
                onClick={() => {
                  setInternalValue(undefined);
                  setSelectedInternalCustomer(undefined);
                  setModalVisible(false);
                  setWeight(0);
                  setReviewType('all');
                }}>
                Cancel
              </Button>
              <Button
                type="primary"
                disabled={!selectedInternalCustomer || !internalValue}
                onClick={() => setInternalCustomerValues()}>
                Save
              </Button>
            </div>
          </Row>
        }
        destroyOnClose>
        <div style={{ marginLeft: 20, marginRight: 20 }}>
          {teamSet.length !== 0 && (
            <>
              <Row style={{ alignItems: 'center', marginTop: 20 }}>
                <Space>
                  <Typography.Title level={5}>Type</Typography.Title>
                </Space>
              </Row>
              <Divider style={{ marginTop: 0, marginBottom: 20 }} />
              <Radio.Group
                options={options}
                onChange={(e) => setInternalCustomerType(e.target.value)}
                value={internalCustomerType}
                disabled={!!internalValue || leader}
              />
            </>
          )}
          <Row style={{ alignItems: 'center', marginTop: 20 }}>
            <Space>
              <Typography.Title level={5}>
                {internalCustomerType === 'team'
                  ? 'Team'
                  : internalCustomerType === 'user'
                  ? 'User'
                  : ''}
              </Typography.Title>
            </Space>
          </Row>
          <Divider style={{ marginTop: 0, marginBottom: 20 }} />
          <Col span={15} style={{ marginBottom: 20 }}>
            {internalCustomerType === 'team' ? (
              <AutoCompleteInput
                id={'team'}
                style={{ display: 'block' }}
                placeholder={`Select ${label}`}
                onChange={(value: number) => {
                  const item = teamSet.find((team) => team.id === value);
                  if (item) {
                    setSelectedInternalCustomer(item);
                  }
                }}
                values={teamSet
                  ?.filter((e) => e.id !== +params.id)
                  .filter((e) => !internalCustomerIds.some((e2) => e.id === e2))}
                disabled={leader}
                value={selectedInternalCustomer?.id}
              />
            ) : (
              <AutoCompleteInput
                id={'user'}
                style={{ display: 'block' }}
                placeholder={`Select ${label}`}
                onChange={(value: number) => {
                  const item = userSet.find((user) => user.id === value);
                  if (item) {
                    setSelectedInternalCustomer(item);
                  }
                }}
                disabled={leader}
                values={userSet?.filter((e) => e.id !== +params.id)}
                value={selectedInternalCustomer?.id}
              />
            )}
          </Col>
          <Row style={{ alignItems: 'center' }}>
            <Space>
              <Typography.Title level={5}>Criteria Set</Typography.Title>
            </Space>
          </Row>
          <Divider style={{ marginTop: 0, marginBottom: 20 }} />
          <Row>
            <Col span={15}>
              <AutoCompleteInput
                style={{ display: 'block' }}
                placeholder="Select Criteria Set"
                onChange={(e: number) => {
                  setInternalValue(e);
                }}
                disabled={leader}
                values={criteriaSet.map((e) => ({ id: e.id, value: e.name }))}
                value={internalValue}
              />
            </Col>
          </Row>
          <Space size={25} />
          <Row>
            <Col span={18}>
              {internalValue &&
                criteriaSet
                  .find((e1) => e1.id == internalValue)
                  .criterias.map((e: any) => (
                    <div
                      key={e.id}
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        border: '1px solid rgba(56,54,48,.16)',
                        marginTop: 5,
                        padding: 5,
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}>
                      <Text>{e.name}</Text>
                    </div>
                  ))}
            </Col>
          </Row>
          <Row style={{ alignItems: 'center', marginTop: 20 }}>
            <Space>
              <Typography.Title level={5}>Weight</Typography.Title>
            </Space>
          </Row>
          <Divider style={{ marginTop: 0, marginBottom: 20 }} />
          <InputNumber
            onChange={(e) => {
              setWeight(e ?? 0);
            }}
            onBlur={(e: any) => {
              setWeight(e.target.value);
            }}
            keyboard={true}
            min={0}
            type={'number'}
            value={weight}
            style={{ width: '50%' }}
          />
          {internalCustomerType === 'team' && (
            <>
              <Row style={{ alignItems: 'center', marginTop: 20 }}>
                <Space>
                  <Typography.Title level={5}>Review Type</Typography.Title>
                </Space>
              </Row>
              <Divider style={{ marginTop: 0, marginBottom: 20 }} />
              <Radio.Group
                options={options1}
                onChange={(e) => setReviewType(e.target.value)}
                value={reviewType}
                disabled={leader}
              />
            </>
          )}
        </div>
      </Modal>
      <Modal
        open={modalVisible1}
        onCancel={() => {
          setInternalValue(undefined);
          setSelectedInternalCustomer(undefined);
          setSelectedOldInternalCustomer(undefined);
          setModalVisible1(false);
        }}
        footer={
          <Row>
            {!leader && (
              <Button
                danger
                onClick={() => showDeleteConfirm()}
                disabled={selectedStatus !== 'not submitted' && selectedStatus !== undefined}
                style={{
                  display: selectedInternalCustomer ? 'flex' : 'none',
                }}>
                Delete
              </Button>
            )}
            <div style={{ flex: 1 }}>
              <Button
                onClick={() => {
                  setInternalValue(undefined);
                  setSelectedInternalCustomer(undefined);
                  setSelectedOldInternalCustomer(undefined);
                  setModalVisible1(false);
                  setWeight(0);
                  setReviewType('all');
                }}>
                Cancel
              </Button>
              <Button
                type="primary"
                disabled={!selectedInternalCustomer || !internalValue}
                onClick={() => editInternalCustomerValues()}>
                Edit
              </Button>
            </div>
          </Row>
        }
        destroyOnClose>
        <div style={{ marginLeft: 20, marginRight: 20 }}>
          {teamSet.length !== 0 && (
            <>
              <Row style={{ alignItems: 'center', marginTop: 20 }}>
                <Space>
                  <Typography.Title level={5}>Type</Typography.Title>
                </Space>
              </Row>
              <Divider style={{ marginTop: 0, marginBottom: 20 }} />
              <Radio.Group
                options={options}
                onChange={(e) => setInternalCustomerType(e.target.value)}
                value={internalCustomerType}
                disabled={!!internalValue || leader}
              />
            </>
          )}
          <Row style={{ alignItems: 'center', marginTop: 20 }}>
            <Space>
              <Typography.Title level={5}>
                {internalCustomerType === 'team'
                  ? 'Team'
                  : internalCustomerType === 'user'
                  ? 'User'
                  : ''}
              </Typography.Title>
            </Space>
          </Row>
          <Divider style={{ marginTop: 0, marginBottom: 20 }} />
          <Col span={15} style={{ marginBottom: 20 }}>
            {internalCustomerType === 'team' ? (
              <AutoCompleteInput
                style={{ display: 'block' }}
                placeholder={`Select ${label}`}
                onChange={(value: number) => {
                  const item = teamSet.find((team) => team.id === value);
                  if (item) {
                    setSelectedInternalCustomer(item);
                  }
                }}
                disabled={leader}
                value={selectedInternalCustomer?.id}
                values={teamSet
                  ?.filter((e) => e.id !== +params.id)
                  .filter((e) => !internalCustomerIds.some((e2) => e.id === e2))}
              />
            ) : (
              <AutoCompleteInput
                style={{ display: 'block' }}
                placeholder={`Select ${label}`}
                onChange={(value: number) => {
                  const item = userSet.find((user) => user.id === value);
                  if (item) {
                    setSelectedInternalCustomer(item);
                  }
                }}
                disabled={leader}
                value={selectedInternalCustomer?.id}
                values={
                  userSet?.filter((e) => e.id !== +params.id)
                  // .filter((e) => !internalCustomerIds.some((e2) => e.id === e2))
                }
              />
            )}
          </Col>
          <Row style={{ alignItems: 'center' }}>
            <Space>
              <Typography.Title level={5}>Criteria Set</Typography.Title>
            </Space>
          </Row>
          <Divider style={{ marginTop: 0, marginBottom: 20 }} />
          <Row>
            <Col span={15}>
              <AutoCompleteInput
                style={{ display: 'block' }}
                placeholder="Select Criteria Set"
                onChange={(e: number) => {
                  setInternalValue(e);
                }}
                disabled={leader}
                values={criteriaSet.map((e) => ({ id: e.id, value: e.name }))}
                value={internalValue}
              />
            </Col>
          </Row>
          <Space size={25} />
          <Row>
            <Col span={18}>
              {internalValue &&
                criteriaSet
                  .find((e1) => e1.id == internalValue)
                  .criterias.map((e: any) => (
                    <div
                      key={e.id}
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        border: '1px solid rgba(56,54,48,.16)',
                        marginTop: 5,
                        padding: 5,
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}>
                      <Text>{e.name}</Text>
                    </div>
                  ))}
            </Col>
          </Row>
          <Row style={{ alignItems: 'center', marginTop: 20 }}>
            <Space>
              <Typography.Title level={5}>Weight</Typography.Title>
            </Space>
          </Row>
          <Divider style={{ marginTop: 0, marginBottom: 20 }} />
          <InputNumber
            onChange={(e) => {
              setWeight(e ?? 0);
            }}
            onBlur={(e: any) => {
              setWeight(e.target.value);
            }}
            keyboard={true}
            min={0}
            type={'number'}
            value={weight}
            style={{ width: '50%' }}
          />
          {internalCustomerType === 'team' && (
            <>
              <Row style={{ alignItems: 'center', marginTop: 20 }}>
                <Space>
                  <Typography.Title level={5}>Review Type</Typography.Title>
                </Space>
              </Row>
              <Divider style={{ marginTop: 0, marginBottom: 20 }} />
              <Radio.Group
                options={options1}
                onChange={(e) => setReviewType(e.target.value)}
                value={reviewType}
                disabled={true}
              />
            </>
          )}
        </div>
      </Modal>
    </div>
  );
};
